import { useEffect, useState } from "react";
import "../assets/styles/PurchaseSuccess.css";
import { Modal, ModalBody } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";

export default function PurchaseSuccess() {
  const location = useLocation();
  console.log(location?.state?.expiryDate);
  const navigate = useNavigate();
  const [modal, setModal] = useState(
    location.state ? location.state.showSuccessModal : ""
  );
  const toggleModal = () => {
    setModal(!modal);
  };
  const goToPaidUser = () => {
    localStorage.setItem("dontShowAgree", false);
    localStorage.setItem("dontShowProfile", false);
    navigate("/PurchaseSuccess", {
      state: null,
    });
    setTimeout(function () {
      navigate("/subscribed-user", {
        state: {
          showSuccessModal: true,
          assessmentLeft: location.state.assessmentLeft,
        },
      });
    }, 0);
  };
  useEffect(() => {
    if (location.state == null) {
      if (localStorage.getItem("isTrial") == "true") {
        navigate("/trial-user");
      } else if (localStorage.getItem("isTrial") == "false") {
        navigate("/subscribed-user");
      }
    }
  }, []);
  return location.state == null ? (
    <div></div>
  ) : (
    <div>
      <Modal isOpen={modal} size="md" toggle={toggleModal}>
        <ModalBody>
          <div className="pop-up">
            <span className="pop-up-Purchase-successful">
              {" "}
              Purchase successful
            </span>

            <div className="pop-up-details">
              <span className="pop-up-details-DrSharath">
                {localStorage.getItem("userName")}
              </span>

              <span className="pop-up-details-msg">
                Added <b>{location?.state?.totalAssessments}</b> new assessments
                valid till {location?.state?.expiryDate.split(' ')[0]}.<br></br> And your
                balance is updated
              </span>

              <b className="pop-up-details-assessments-left-num">
                {location?.state?.assessmentLeft}
              </b>

              <p className="pop-up-details-assessments-left">
                Assessments Left
              </p>
            </div>
            <div onClick={goToPaidUser} className="done">
              <span className="done-text"> Done</span>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}
